module.exports = __webpack_public_path__ + "img/notification@3x.9620d8fa.png";